import { useEffect, useState, useRef, useContext } from "react";
import { useParams, useHistory } from "react-router";
import { Link } from "react-router-dom";

import { LayoutContext } from "../layout/";

import { cookie } from 'shared-kernel/helpers';
import { getAllProducts, updateProduct, removeProduct } from '../preinvoice/storage';

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function PreInvoice2(props) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [focusedId, setFocusedId] = useState(null);

    const history = useHistory();
    const cartIdRef = useRef(cookie.get('cid'));

    const { brandId } = useParams();

    const formatNumber = n => n && n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const fetchData = async () => {
        const products = getAllProducts();

        try {
            const response = await fetch(getEndpoint(`/api/android/product/getby?brandId=${brandId}&productIds=${products.map(x => x.id).join(',')}`));
            const json = await response.json();
            const data = {
                items: json.data,
                totalPrice: 0,
                totalDiscount: 0,
                payablePrice: 0,
                totalQuantity: 0
            }

            for (const item of data.items) {
                item.quantity = products.find(x => x.id == item.id).quantity;
            }

            for (const item of data.items) {
                data.totalPrice += (item.oldPrice * item.quantity);
                data.payablePrice += (item.price * item.quantity);
                data.totalQuantity += item.quantity;
            }

            data.totalDiscount = data.totalPrice - data.payablePrice;

            setData(data);

        } catch (err) {
            if (err.name !== "AbortError") setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = id => {
        removeProduct(id);
        fetchData();
    }

    const handleUpdate = (id, prevQuantity, mode) => {
        updateProduct(id, mode === '+' ? prevQuantity + 1 : prevQuantity - 1);
        fetchData();
    }

    const handleUpdate2 = (id, q) => {
        updateProduct(id, q);
        fetchData();
    }

    const ProductBox = ({ id, brandTitle, title, price, oldPrice, discount, picture, quantity, focused, setFocusedId }) => {
        const [localQty, setLocalQty] = useState(quantity);
        const timeoutRef = useRef(null);
        const inputRef = useRef(null);

        useEffect(() => {
            setLocalQty(quantity);
        }, [quantity]);

        // مدیریت فوکوس
        useEffect(() => {
            if (focused && inputRef.current) {
                inputRef.current.focus();
            }
        }, [focused]);

        const handleFocus = () => setFocusedId(id);

        const handleChange = (e) => {
            let value = e.target.value;
            setLocalQty(value);

            if (timeoutRef.current) clearTimeout(timeoutRef.current);

            if (value === '') return;
            if (+value < 1) value = 1;

            timeoutRef.current = setTimeout(() => {
                setLocalQty(value);

                handleUpdate2(id, +value);
            }, 500);
        };

        const handleBlur = () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }

            if (localQty === '' || +localQty < 1) {
                const corrected = 1;
                setLocalQty(corrected);
                handleUpdate2(id, corrected);
            }
        };

        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <div className='box p-r d-f bc-w bw-1 bc--n3 br-3 mb-4'>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <Img />
                </div>
                <div className='px-2' style={{ width: '82%' }}>
                    <div className='p-r t-1'>
                        <div className='lh-2'>{title}</div>
                        <div className='p-r' style={{ fontSize: '.75em', color: '#777777', top: '-.4em' }}>{brandTitle}</div>
                    </div>
                    <div className='d-f ai-c'>
                        <div className='d-f ai-c jc-c _bc-g-d c-w p-1 br-4'>
                            <div className='d-l fs-4'>{discount}%</div>
                        </div>
                        <div className='mr-2 fw-600'>
                            <div className='d-f ai-c mt-1'>
                                <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                &nbsp;
                                <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                            </div>
                            <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.5em' }}>
                                <div className='fs-3' style={{}}>{formatNumber(price)}</div>
                                &nbsp;
                                <div style={{ fontSize: '.8em' }}>ریال</div></div>
                        </div>
                        <div style={{ borderColor: '#acacac', width: '40%' }} className='mr-a fs-3 bw-1 br-3 d-f ai-c'>
                            <svg className='d-b fsh-0 fg-0' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(id, quantity, '+')}>
                                <path fill='#075e54' d="M25.313 15.781h-8v8h-2.625v-8h-8v-2.625h8v-8h2.625v8h8v2.625z"></path>
                            </svg>
                            <input
                                className='ta-c bc-t w-100'
                                type="number"
                                value={localQty}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onFocus={handleFocus}
                            />
                            <svg className='d-b fsh-0 fg-0 mr-a' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(id, quantity, '-')}>
                                <path fill='#075e54' d="M25.313 15.781h-18.625v-2.625h18.625v2.625z"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" className='p-a l-1 t-1' onClick={e => handleDelete(id)}>
                    <path fill='#ff0000' d="M25.313 7.031l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                </svg>
            </div>
        );
    }

    const handleAddToCart = () => {
        const products = getAllProducts();
        const submitData = {
            cartId: cartIdRef.current,
            brandId: brandId,
            products: []
        };

        for (const item of products) {
            submitData.products.push({
                id: item.id,
                quantity: item.quantity
            });
        }

        fetch(getEndpoint("/api/cart/add"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(submitData)

        })
            .then(res => res.json())
            .then(data => {
                history.push('/cart');
            });
    }

    useEffect(() => {
        setPageTitle('پیش فاکتور');

        setLoading(true);
        fetchData();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    if (data.items.length === 0) {
        return (
            <div className='d-f ai-c jc-c h-100' style={{ backgroundColor: '#f5f5f5' }}>
                <div>
                    <img className='w-9 mx-a mb-4' src={getEndpoint("/pwa/img/empty_cart.png")} />
                    <div>سبد خرید شما خالی است!</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '9rem' }}>
                {data.items.map(x => {
                    return (
                        <ProductBox
                            key={x.id}
                            id={x.id}
                            title={x.title}
                            brandTitle={x.brandTitle}
                            price={x.price}
                            oldPrice={x.oldPrice}
                            discount={x.discount}
                            picture={x.picture}
                            quantity={x.quantity}
                            focused={focusedId === x.id}
                            setFocusedId={setFocusedId}
                        />
                    )
                })}

                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع خرید ({data.totalQuantity} کالا):</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalPrice)} ریال</div>
                </div>
                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع تخفیف</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalDiscount)} ریال</div>
                </div>
            </div>
            <div className='p-f b-0 l-0 r-0'>
                <div className="d-f ai-c bc-w px-4 fs-3 btw-1" style={{ height: '4rem', borderTopColor: '#ddd' }}>
                    <div className=''>مبلغ قابل پرداخت</div>
                    <div className='mr-a fw-600'>{formatNumber(data.payablePrice)} ریال</div>
                </div>
                <button type='button' className='d-f ai-c jc-c c-w fs-3 w-100 _bc-b' style={{ height: '5rem' }} onClick={handleAddToCart}>افزودن به سبد خرید</button>
            </div>
        </>
    );
}